import _styled from"styled-components";/**
 * Wraps the delete button below the form, in its own `MainContainer` so it lines up with the
 * form's left edge without touching `EditTranslationForm`, which owns the form's own container.
 */export const DeleteContainer=_styled.div.withConfig({displayName:"styles__DeleteContainer",componentId:"sc-1e5g75s-0"})(["display:flex;"]);